//Account ID : 429556453395
const aws = {
  aws_project_region: 'ap-south-1',
  aws_cognito_region: 'ap-south-1',
  aws_user_pools_id: 'ap-south-1_UL05sWBeG',
  aws_user_pools_web_client_id: '7crb1v5671jub4phv1phli5mtm',
  aws_cognito_identity_pool_id: 'ap-south-1:1608bbc3-e022-407f-9a05-07777b82e65c',
  aws_iot_endpoint: 'wss://a3t7o9jx4m20m3-ats.iot.ap-south-1.amazonaws.com/mqtt',

  // Auth configuration
  aws_cognito_signup_attributes: ['email'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['email'],

  // OAuth / Hosted UI configuration (optional)
  oauth: {
    // Amplify expects the domain without the protocol
    domain: 'ap-south-1nlpa0vfew.auth.ap-south-1.amazoncognito.com',
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    // Amplify commonly expects single-string redirect URLs; the CLI may
    // generate arrays. Both work when configuring manually, but keep simple.
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/',
    responseType: 'token', // or 'code' if you use authorization code grant
  },
  PubSub: {
    AWSIoT: {
      region: 'ap-south-1',
      endpoint: 'wss://a3t7o9jx4m20m3-ats.iot.ap-south-1.amazonaws.com/mqtt',
    }
  }
};

export default aws;
